import type { DecorationWidgetConfig } from '../../types'

export const widgetConfig: DecorationWidgetConfig = {
  type: "cms-feed",
  name: "内容流",
  icon: "流",
  group: "CMS通用",
  description: "展示已发布内容的流式列表。",
  defaultProps: {
    "title": "推荐内容",
    "layoutMode": "MIXED",
    "pageSize": 20,
    "showAuthor": true,
    "showPublishedAt": true,
    "showSummary": true,
    "showMetrics": true,
    "showSectionHeader": false,
    "sectionTitle": "",
    "moreText": "",
    "moreLink": ""
}
}
